import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  isLive: boolean;
  htmlFor: string;
}

const LabelWrapper = ({ children, isLive, htmlFor }: Props) => {
  return (
    <label className={classNames('relative', isLive ? 'cursor-pointer' : 'pointer-events-none')} htmlFor={htmlFor}>
      {children}
    </label>
  );
};

export default LabelWrapper;
